import type { DialogueInterface, ReviewCommentInterface, ReviewDeliveryInterface } from 'modules/review/review.interface';
import type { ReviewActiveType } from 'modules/review/review.enum';

export interface CompanyReviewInterface {
    id: number;
    companyId: number;
    author: string;
    company: {
        name: string;
        slug: string;
    };
    content: string;
    active: ReviewActiveType;
    isComplainted: boolean;
    isCredible: boolean;
    averageRating: number;
    likesCount?: number;
    dislikesCount?: number;
    dialogue?: DialogueInterface | null;
    deliveryReview?: ReviewDeliveryInterface | null;
    companyComment?: ReviewCommentInterface | null;
    withdrawnReviewId?: number;
    createdAt: Date;
}

export enum CompanyReviewSortingFields {
    creationDate = 'createdAt',
    rating = 'averageRating'
}
